import React, { useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';

const AppContainer = styled.div`
  display: flex;
  height: 100vh;
  background: var(--background);
  color: var(--text-primary);
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const MainContent = styled.main`
  flex: 1;
  overflow-x: hidden;
  background: #ffffff;
  height:100%
`;

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };
  
  return (
    <AppContainer>
      <Sidebar collapsed={sidebarCollapsed} />
      <ContentWrapper>
        <Header toggleSidebar={toggleSidebar} isSidebarCollapsed={sidebarCollapsed} />
        <MainContent>{children}</MainContent>
      </ContentWrapper>
    </AppContainer>
  );
};

export default Layout;
